import reportError from 'ha/helpers/bugsnag/reportError';
import {
  getUser,
  getUserId,
  getIsAliased,
  getUserIdAlias,
  getUserTraits,
} from 'ha/modules/AuthLogic/selectors';

const identify = (aliasId, data) => ({
  type: 'Analytics.identify',
  meta: {
    analytics: {
      type: 'identify',
      payload: {
        aliasId,
        data,
      },
    },
  },
});

const alias = aliasId => ({
  type: 'Analytics.alias',
  meta: {
    analytics: {
      type: 'alias',
      payload: aliasId,
    },
  },
});

const identifyUser = () => (dispatch, getState, { apiV2, segment }) => {
  const state = getState();
  const user = getUser(state);

  if (!user) {
    segment.identifyUser();

    return;
  }

  const userId = getUserId(state);
  const aliasId = getUserIdAlias(state);
  const data = getUserTraits(state);

  if (getIsAliased(state)) {
    dispatch(identify(aliasId, data));
    segment.identifyUser();
  } else {
    dispatch(alias(aliasId));

    apiV2.updateUser(userId, { isAliased: true }).catch(reportError);

    setTimeout(() => {
      dispatch(identify(aliasId, data));
      segment.identifyUser();
    }, 2000);
  }
};

export default identifyUser;
